// extracted by mini-css-extract-plugin
export default {"infoIconWrapper":"TableHeaderTooltip_infoIconWrapper__b2UlV","infoIcon":"TableHeaderTooltip_infoIcon__TLeSO"};